if (window.top.location.origin !== window.self.location.origin) {
    console.warn(`The domain ${window.self.location.host} does not permit being embedded in an iframe. Redirecting to the iframe URL.`);
    
    const redirectUrl = new URL(window.self.location.href);
    redirectUrl.searchParams.append('iframeBreak', 'true');
    redirectUrl.searchParams.append('originUrl', window.top.location.href);
   
    window.top.location = redirectUrl.href;
}